import { render } from "./DefRating.vue?vue&type=template&id=064c8127"
import script from "./DefRating.vue?vue&type=script&lang=js"
export * from "./DefRating.vue?vue&type=script&lang=js"

import "./DefRating.vue?vue&type=style&index=0&id=064c8127&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__